(function () {
  'use strict';

  angular.module('app').component('packagePriceDetail', packagePriceDetail());

  function packagePriceDetail() {
    return {
      bindings: {
        packagePrices: '=',
        package: '=',
        paxRanges: '=',
        seasonSelected: '=',
        priceListSelected: '=',
        onPackagePricesSaved: '&',
        onPackagePricesCanceled: '&',
      },
      controller: PackagePriceDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/package-prices/package-price-detail/package-price-detail.component.html',
    };
  }

  PackagePriceDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'PackagePriceService',

    // Angular downgraded service
    'paxRangeService',
  ];

  function PackagePriceDetailComponent(config, UtilService, PackagePriceService, paxRangeService) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    vm.dateDisplay = config.DATE_DISPLAY;
    vm.hourDisplay = config.HOUR_DISPLAY; // Ex: 01:00 PM

    vm.selectPaxRange = selectPaxRange;
    vm.openSuggestedPackagePrices = openSuggestedPackagePrices;

    vm.savePackagePrices = savePackagePrices;
    vm.cancel = cancel;

    vm.$onInit = function () {
      var paxRangeToSelect = '';

      // ng-dropdown settings
      vm.paxRangesSelected = [];
      vm.paxRangesSettings = {
        displayProp: 'name',
        showCheckAll: false,
        showUncheckAll: false,
        smartButtonMaxItems: 5,
        dynamicTitle: false,
        styleActive: true,
      };

      vm.paxRangesEvents = {
        onItemSelect: function (item) {
          selectPaxRange(item);
        },
        onItemDeselect: function (item) {
          if (vm.paxRangesSelected.length > 0) {
            paxRangeToSelect = vm.paxRangesSelected[0];
          } else {
            // Select at least one pax range
            paxRangeToSelect = item;
            vm.paxRangesSelected.push(item);
          }

          selectPaxRange(paxRangeToSelect);
        },
      };

      vm.translationText = {
        buttonDefaultText: 'Pax ranges',
      };

      if (vm.packagePrices.length > 0) {
        // Edit and exists prices
        setPaxRangesSelected();
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRangesSelected);

        setItemOptions(vm.packagePrices[0].updated_at);
      } else {
        // Create
        paxRangeToSelect = paxRangeService.getLowestPaxRange(vm.paxRanges);
        vm.paxRangesSelected.push(paxRangeToSelect);

        vm.lastUpdatedAt = false;

        vm.saveButtonLabel = 'SAVE_PRICES';
      }

      setPaxRangesData();
      selectPaxRange(paxRangeToSelect);
    };

    function setItemOptions(updateAt) {
      vm.editMode = true;

      vm.lastUpdatedAt = updateAt;
      vm.saveButtonLabel = 'UPDATE_PRICES';
    }

    // ----- PAX RANGES ----- //
    function selectPaxRange(paxRange) {
      vm.paxRangeSelected = paxRange;
    }

    // Sets the selected Pax Ranges options in the Pax range selector
    function setPaxRangesSelected() {
      vm.paxRangesSelected = [];

      vm.packagePrices.forEach(function (packagePrice) {
        vm.paxRanges.forEach(function (paxRange) {
          if (!checkIfPaxRangeExist(paxRange) && packagePrice.pax_range_id === paxRange.id) {
            vm.paxRangesSelected.push(paxRange);
          }
        });
      });

      if (vm.paxRangesSelected.length === 0) {
        // fix
        vm.paxRangesSelected = [vm.paxRanges[0]];
      }
    }

    function checkIfPaxRangeExist(paxRange) {
      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        if (vm.paxRangesSelected[i] === paxRange) {
          return true;
        }
      }

      return false;
    }

    // Seta all prices from the paxRange data, new or saved on the DB
    function setPaxRangesData() {
      vm.paxRangesData = [];

      vm.paxRanges.forEach(function (paxRange) {
        paxRange.schedules = [];
        paxRange.schedules.push(setPaxRangePrices(paxRange));

        vm.paxRangesData.push(paxRange);
      });
    }

    function setPaxRangePrices(paxRange) {
      var packagePriceId;
      var adultPrice = '',
        childPrice = 0,
        infantPrice = 0,
        seniorPrice = 0;

      var packagePrice;

      // Exist package prices
      if (vm.packagePrices.length > 0) {
        for (var i = 0; i < vm.packagePrices.length; i++) {
          packagePrice = vm.packagePrices[i];

          if (packagePrice.pax_range_id === paxRange.id) {
            packagePriceId = packagePrice.id;

            adultPrice = packagePrice.adult_price;
            childPrice = packagePrice.child_price;
            infantPrice = packagePrice.infant_price;
            seniorPrice = packagePrice.senior_price;
            break;
          }
        }
      }

      var schedule = {
        adult_price: adultPrice,
        child_price: childPrice,
        infant_price: infantPrice,
        senior_price: seniorPrice,
        packagePriceId: null,
      };

      if (packagePriceId) {
        schedule.packagePriceId = packagePrice.id;
      }

      return schedule;
    }

    function openSuggestedPackagePrices() {
      // var successCallback = function(){
      //     console.log('successCallback');
      // };

      var data = {
        package: vm.package,
        season: vm.seasonSelected,
        priceList: vm.priceListSelected,
        paxRange: vm.paxRangesSelected[0],
      };

      // console.log(data);

      PackagePriceService.openSuggestedPackagePricesModal(data, {});
    }

    function savePackagePrices(isFormValid) {
      if (!isFormValid) {
        return;
      }

      var packagePrices = [];

      for (var i = 0; i < vm.paxRangesSelected.length; i++) {
        var paxRangeSelected = vm.paxRangesSelected[i];

        for (var j = 0; j < vm.paxRangesData.length; j++) {
          var paxRangeData = vm.paxRangesData[j];

          if (paxRangeData.id === paxRangeSelected.id) {
            paxRangeData.schedules.forEach(function (schedule) {
              var price = {
                adult_price: schedule.adult_price || 0,
                child_price: schedule.child_price || 0,
                infant_price: schedule.infant_price || 0,
                senior_price: schedule.senior_price || 0,

                pax_range_id: paxRangeSelected.id,
                id: null,
              };

              if (schedule.packagePriceId) {
                price.id = schedule.packagePriceId;
              }

              packagePrices.push(price);
            });

            break; // check
          }
        }
      }

      var params = {
        package_prices: packagePrices,
        price_list_id: vm.priceListSelected.id,
        season_id: vm.seasonSelected.id,
      };

      vm.sendingForm = true;
      PackagePriceService.savePackagePrices(vm.package, params, vm.editMode).then(function (data) {
        if (data) {
          vm.onPackagePricesSaved();

          setItemOptions(data[0].updated_at);

          vm.packagePrices = data;
          setPaxRangesData();
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onPackagePricesCanceled();
    }
  }
})();
